import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(async (nuxtApp) => {
  // No need to provide loader since we're handling imports directly in composable
  // The registry is imported directly in the composable when needed
  nuxtApp.provide('builderComponents', null)
})
